import { isString, toUpper } from 'lodash-es';

import { CrossFieldValidatorFn } from '../dynamic-form.component';
import { UntypedFormGroup } from '@angular/forms';
import { ZIP_CODE_BY_COUNTRY_REGEX } from 'src/app/shared/enums/zip.enums';
import { validString } from 'src/app/shared/utilities/types.utils';

export function crossFieldZipCodeValidator(zipFieldName: string, countryFieldName: string): CrossFieldValidatorFn {
	const validator = (formGroup: UntypedFormGroup): null => {
		const zipControl = formGroup.get(zipFieldName);
		const countryControl = formGroup.get(countryFieldName);
		const selectedCountry = isString(countryControl.value) ? toUpper(countryControl.value).slice(0, 2) : '';
		const regexp = ZIP_CODE_BY_COUNTRY_REGEX[selectedCountry] || ZIP_CODE_BY_COUNTRY_REGEX.INTL;

		if (!zipControl || !validString(selectedCountry)) {
			return null;
		}

		const zipValue = isString(zipControl.value) ? zipControl.value.trim() : '';
		const isValidZip = regexp.test(zipValue);

		if (!isValidZip) {
			zipControl.setErrors({
				match: selectedCountry,
				zipCode: true,
			});
		}

		return null;
	};

	validator.sourceFieldName = zipFieldName;
	validator.modifierFieldName = countryFieldName;
	validator.isZipCodeValidator = true;

	return validator;
}
